const BASE_URL = process.env.REACT_APP_BACKEND_URL || '';

const getToken = () => {
  try { return localStorage.getItem('token'); } catch { return null; }
};

const headers = () => ({
  'Content-Type': 'application/json',
  ...(getToken() ? { Authorization: `Bearer ${getToken()}` } : {})
});

// Requête JSON unique : renvoie toujours un objet (avec `error` en cas d'échec),
// pour rester compatible avec le code existant qui teste `data.error`.
const request = async (path, options = {}) => {
  try {
    const res = await fetch(`${BASE_URL}${path}`, { ...options, headers: { ...headers(), ...(options.headers || {}) } });
    const data = await res.json().catch(() => ({}));
    if (!res.ok && !data.error) return { error: `Erreur ${res.status}`, status: res.status };
    if (!res.ok) return { ...data, status: res.status };
    return data;
  } catch (e) {
    return { error: 'Connexion impossible. Vérifiez votre réseau.', offline: true };
  }
};

const post = (path, body) => request(path, { method: 'POST', body: JSON.stringify(body) });
const put = (path, body) => request(path, { method: 'PUT', body: JSON.stringify(body) });

export const api = {
  // Auth
  register: (nom, email, password) => post('/api/auth/register', { nom, email, password }),
  login: (email, password) => post('/api/auth/login', { email, password }),
  sendOTP: (email) => post('/api/auth/otp/send', { email }),
  verifyOTP: (email, otp) => post('/api/auth/otp/verify', { email, otp }),
  changePassword: (ancien_password, nouveau_password) => post('/api/auth/change-password', { ancien_password, nouveau_password }),
  me: () => request('/api/auth/me'),
  googleLogin: () => { window.location.href = `${BASE_URL}/api/auth/google`; },

  // Lieux (table `adresses`)
  getAdresses: () => request('/api/adresses'),
  getConfig: () => request('/api/adresses/config'),
  searchAdresses: (q) => request(`/api/adresses/search?q=${encodeURIComponent(q)}`),
  createAdresse: (data) => post('/api/adresses', data),
  updateAdresse: (id, data) => put(`/api/adresses/${id}`, data),
  setPrincipal: (id) => put(`/api/adresses/${id}/principal`, {}),
  deleteAdresse: (id) => request(`/api/adresses/${id}`, { method: 'DELETE' }),
  getPublicAdresse: (code) => request(`/api/adresses/public/${encodeURIComponent(code)}`),

  // Admin
  getUsers: () => request('/api/admin/users'),
  updateUserRole: (id, role) => put(`/api/admin/users/${id}/role`, { role }),
  updateUserStatut: (id, statut) => put(`/api/admin/users/${id}/statut`, { statut }),
  deleteUser: (id) => request(`/api/admin/users/${id}`, { method: 'DELETE' }),
  getStats: () => request('/api/admin/stats'),
  getSettings: () => request('/api/admin/settings'),
  updateSetting: (key, value) => put(`/api/admin/settings/${key}`, { value }),

  // Module SIG
  sigStatus: () => request('/api/sig/status'),
  sigCouches: () => request('/api/sig/couches'),
  sigLieux: (commune = '') => request(`/api/sig/lieux${commune ? '?commune=' + encodeURIComponent(commune) : ''}`),
  sigExport: async (body) => {
    try {
      const res = await fetch(`${BASE_URL}/api/sig/export`, {
        method: 'POST',
        headers: headers(),
        body: JSON.stringify(body),
      });
      if (!res.ok) {
        const data = await res.json().catch(() => ({}));
        return { error: data.error || `Erreur ${res.status}` };
      }
      const disposition = res.headers.get('Content-Disposition') || '';
      const match = disposition.match(/filename="?([^"]+)"?/);
      const filename = match ? match[1] : `export.${body.format}`;
      const blob = await res.blob();
      return { blob, filename };
    } catch {
      return { error: 'Connexion impossible. Vérifiez votre réseau.' };
    }
  },

  // Admin SIG
  sigAdminConfig: () => request('/api/admin/sig/config'),
  sigAdminToggle: (actif) => put('/api/admin/sig/config', { sig_module_actif: actif }),
  sigAdminGrantAccess: (user_id, formats) => post('/api/admin/sig/permissions', { user_id, formats }),
  sigAdminRevokeAccess: (user_id) => request(`/api/admin/sig/permissions/${user_id}`, { method: 'DELETE' }),
  sigAdminSuspend: (user_id) => request(`/api/admin/sig/permissions/${user_id}/suspendre`, { method: 'PUT' }),
  sigAdminReactivate: (user_id) => request(`/api/admin/sig/permissions/${user_id}/reactiver`, { method: 'PUT' }),
  sigAdminLogs: () => request('/api/admin/sig/logs'),
};
